import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function Faq({ items, title = "Frequently Asked Questions", testIdPrefix = "faq" }) {
    const [open, setOpen] = useState(0);
    return (
        <section className="border-t border-black/10" data-testid={`${testIdPrefix}-section`}>
            <div className="mx-auto max-w-4xl px-4 md:px-8 py-16">
                <div className="ui-heading text-xs uppercase tracking-widest text-ink-muted mb-3">/ frequently asked</div>
                <h2 className="font-display font-black tracking-tighter text-3xl md:text-4xl mb-8">{title}</h2>
                <ul className="border border-black/10 bg-white divide-y divide-black/10">
                    {items.map((it, i) => (
                        <li key={i} data-testid={`${testIdPrefix}-item-${i}`}>
                            <button
                                onClick={() => setOpen(open === i ? -1 : i)}
                                className="w-full text-left px-5 py-4 flex items-center justify-between gap-3 hover:bg-paper transition-colors"
                                aria-expanded={open === i}
                            >
                                <span className="ui-heading font-semibold text-ink">{it.q}</span>
                                <ChevronDown size={16} className={`shrink-0 transition-transform ${open === i ? "rotate-180" : ""}`} />
                            </button>
                            {open === i && (
                                <div className="px-5 pb-5 text-sm text-ink-soft leading-relaxed" data-testid={`${testIdPrefix}-answer-${i}`}>{it.a}</div>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
